module.exports = __webpack_public_path__ + "static/4-e5e4efc1bc6b4accf99fd656b5cee5ac.png";